import { render, staticRenderFns } from "./BasicCell.vue?vue&type=template&id=6679f77f&scoped=true&lang=html&"
import script from "./BasicCell.vue?vue&type=script&lang=js&"
export * from "./BasicCell.vue?vue&type=script&lang=js&"
import style0 from "./BasicCell.vue?vue&type=style&index=0&id=6679f77f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6679f77f",
  null
  
)

export default component.exports